export const MAX_PLAN_REGENERATION_ROWS = 24;

export const planCardTitles: Record<string, readonly string[]> = {
    context: ['Prior knowledge', 'Curriculum alignment'],
    outcomes: ['Learning objectives'],
    language: ['Pronunciation focus', 'Culture & pragmatics'],
    preparation: ['Preparation checklist', 'Board plan'],
    support: ['Anticipated difficulties', 'Differentiation'],
    procedure: ['Classroom procedure', 'Check for understanding'],
    assessment: ['Assessment', 'Companion practice', 'Teacher reflection'],
};

export function findPlanCard<T extends { title: string; section_type?: string | null }>(sections: T[], title: string, index: number): T | null {
    const exact = sections.find(section => section.title === title);
    if (exact) return exact;
    if (title === 'Check for understanding') return null;
    const titles = Object.values(planCardTitles).find(values => values.includes(title));
    if (!titles) return sections[index] ?? null;
    const unmatchedTitles = titles.filter(value => !sections.some(section => section.title === value));
    const legacy = sections.filter(section => !titles.includes(section.title));
    return legacy[unmatchedTitles.indexOf(title)] ?? null;
}

/** The plan panel for a section type; unknown or missing types belong to the procedure. */
export function planSectionPanel(type: string | null | undefined): 'context' | 'outcomes' | 'language' | 'preparation' | 'support' | 'procedure' | 'assessment' {
    return type === 'context' || type === 'outcomes' || type === 'language' || type === 'preparation' || type === 'support' || type === 'assessment' ? type : 'procedure';
}
